export const comments_3249785 = {"data":{"data":[],"links":{}}}